import { emitter } from 'shared/helpers/mitt';
import analyticsHelper from 'dashboard/helper/AnalyticsHelper/index';

const TOAST_VARIANTS = new Set([
  'success',
  'positive',
  'error',
  'alert',
  'warning',
  'info',
]);

const normalizeToastAction = action => {
  if (!action) return null;

  if (typeof action === 'string') {
    return TOAST_VARIANTS.has(action) ? { variant: action } : { message: action };
  }

  if (typeof action !== 'object') return null;

  const normalized = { ...action };
  const inferredVariant =
    normalized.variant ||
    normalized.status ||
    normalized.level ||
    normalized.kind ||
    normalized.toastType;

  if (TOAST_VARIANTS.has(inferredVariant)) {
    normalized.variant = inferredVariant;
  } else if (TOAST_VARIANTS.has(normalized.type)) {
    normalized.variant = normalized.type;
  }

  return normalized;
};

/**
 * Custom hook to track events
 */
export const useTrack = (...args) => {
  try {
    return analyticsHelper.track(...args);
  } catch (error) {
    // Ignore this, tracking is not mission critical
  }

  return null;
};

/**
 * Emits a toast message event using a global emitter.
 * @param {string} message - The message to be displayed in the toast.
 * @param {Object|null} action - Optional callback function or object to execute.
 */
export const useAlert = (message, action = null) => {
  emitter.emit('newToastMessage', { message, action: normalizeToastAction(action) });
};
